<template>
  <v-container>
    <v-row
      v-show="poi.id"
      dense align="center"
      justify="center"
    >
      <v-col>
        <v-menu
          v-if="isPoiAttraction"
          v-model="wikidialog.dialog"
          :close-on-content-click="false"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              fab
              small
              v-bind="attrs"
              v-on="on"
              :disabled="isPoiLocked"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <slot>
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      :color="poi.wikipoi_id ? 'green' : 'grey'"
                    >
                      mdi-wikipedia
                    </v-icon>
                  </slot>
                </template>
                wikipoi flightpath3d
              </v-tooltip>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>Enter WikiPoi ID</v-card-title>
            <v-card-text>
              <v-text-field
                type="number"
                label="wikipoi id"
                single-line
                counter
                v-model="wikidialog.id"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="poi.wikipoi_id"
                :href="wikipoiUrl"
                target="_blank"
                :disabled="isPoiLocked"
              >
                open
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="wikidialog.id = poi.wikipoi_id; wikidialog.dialog = false"
                :disabled="isPoiLocked"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="!wikidialog.id || isPoiLocked"
                @click="setWikipoiId"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <span class="font-weight-bold text--darken-1 blue--text">{{ poi.name }}</span>
        <div class="font-weight-medium pl-4 light-blue--text"> City: {{ poi.city }} </div>
      </v-col>

      <v-col
        cols="2"
        class="d-flex flex-row align-center"
      >
        <div
          class="pa-1 rounded-pill"
          :style="poiTableOptionsSet"
        >ID: {{ $route.params.id }}</div>
      </v-col>

      <v-col>
        <image-upload-dialog
          :object-id="poi.id"
          path="poiImage"
          @addNew="uploadImage"
          :button-disabled="isPoiLocked"
        />
      </v-col>

      <v-col
        v-if="isPoiAttraction"
      >
        <v-btn
          @click="showVideoUploadDialog(false);"
          :disabled="standby || isPoiLocked"
        >
          <v-icon left>
            mdi-paperclip
          </v-icon>
          server upload .mp4 to Vimeo
        </v-btn>
      </v-col>

      <v-col
        v-if="isPoiAttraction"
      >
        <v-btn
          @click="showVideoUploadDialog(true);"
          :disabled="standby || isPoiLocked"
        >
          <v-icon left>
            mdi-paperclip
          </v-icon>
          direct upload .mp4 to Vimeo
        </v-btn>
      </v-col>
      <v-col
        :cols="1"
      >
        <v-text-field
          type="number"
          label="tripexpert id"
          single-line
          v-model="tripexpert.id"
        >
          <v-btn
            slot="append"
            fab
            small
            @click="getTripexpert('tripexpert_id')"
            :disabled="isPoiLocked"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-find-replace
                </v-icon>
              </template>
              get texts via api
            </v-tooltip>
          </v-btn>
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="tripexpert url"
          dense
          v-model="tripexpert.url"
        >
          <v-btn
            slot="append"
            fab
            small
            @click="getTripexpert('url')"
            :disabled="isPoiLocked"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-find-replace
                </v-icon>
              </template>
              get texts via api
            </v-tooltip>
          </v-btn>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="2">
        <v-row
          v-if="!isPoiAttraction"
          dense
          no-gutters
        >
          <v-toolbar
            flat
            color="blue-grey"
            dense
            height="20"
          >
            <v-toolbar-title>Address</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row
          v-if="!isPoiAttraction"
          dense
          no-gutters
          class="my-1"
        >
          <v-edit-dialog
            @save="update(
              {
               address: parsedAddress,
               show_poi: true,
              },
              'address'
             )"
            @open="parsedAddress = {...poi.address}"
            large
          >
            <div class="my-1">
              <span>Street 1:</span>
              <span class="font-weight-black">
                 {{ this.poi.address && this.poi.address.street1
                   ? this.poi.address.street1 : 'empty' }}
              </span>
            </div>
            <div class="my-1">
              <span>Street 2:</span>
              <span class="font-weight-black">
                 {{ this.poi.address && this.poi.address.street2
                  ? this.poi.address.street2 : 'empty' }}
              </span>
            </div>
            <div class="my-1">
              <span>City:</span>
              <span class="font-weight-black">
                 {{ this.poi.address && this.poi.address.city
                  ? this.poi.address.city : 'empty' }}
              </span>
            </div>
            <div class="my-1">
              <span>State:</span>
              <span class="font-weight-black">
                 {{ this.poi.address && this.poi.address.state
                  ? this.poi.address.state : 'empty' }}
              </span>
            </div>
            <div class="my-1">
              <span>Postal Code:</span>
              <span class="font-weight-black">
                 {{ this.poi.address && this.poi.address.postal_code
                  ? this.poi.address.postal_code : 'empty' }}
              </span>
            </div>
            <div class="my-1">
              <span>Country:</span>
              <span class="font-weight-black">
                 {{ this.poi.address && this.poi.address.country
                  ? this.poi.address.country : 'empty' }}
              </span>
            </div>
            <template v-slot:input>
                <v-text-field
                  v-model="parsedAddress.street1"
                  label="Street1"
                />
                <v-text-field
                  v-model="parsedAddress.street2"
                  label="Street 2"
                />
                <v-text-field
                  v-model="parsedAddress.city"
                  label="City"
                />
                <v-text-field
                  v-model="parsedAddress.state"
                  label="State"
                />
                <v-text-field
                  v-model="parsedAddress.postal_code"
                  label="Postal Code"
                />
                <v-text-field
                  v-model="parsedAddress.country"
                  label="Country"
                />
            </template>
          </v-edit-dialog>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense
          no-gutters
        >
          <v-toolbar
            flat
            color="blue-grey"
            dense
            dark
            height="20"
          >
            <v-toolbar-title>Price (USD)</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1"
        >
          <v-edit-dialog
            @save="update(
              { price: poi.price, show_poi: true },
              'price'
              )"
          >
            <div class="my-1">
              <span class="font-weight-black">{{ poi.price ? poi.price : 'empty' }}</span>
            </div>
            <template v-slot:input>
              <v-text-field
                v-model="poi.price"
                label="Price (USD)"
                clearable
              />
            </template>
          </v-edit-dialog>
        </v-row>
        <v-row
          v-if="isPoiRestaurant"
          dense no-gutters
        >
          <v-toolbar
            flat
            color="blue-grey"
            dense
            height="20"
          >
            <v-toolbar-title>Price Category</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row
          v-if="isPoiRestaurant"
          dense
          no-gutters
          class="my-1"
        >
          <v-edit-dialog
            @save="update(
              { price_category: poi.price_category, show_poi: true },
              'price'
              )"
          >
            <div class="my-1">
              <span class="font-weight-black">
                {{ poi.price_category !== null ? poi.price_category : 'empty' }}
              </span>
            </div>
            <template v-slot:input>
              <v-select
                label="Price Category"
                v-model="poi.price_category"
                item-text="name"
                item-value="id"
                :items="computedPriceCategories"
              />
            </template>
          </v-edit-dialog>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters>
          <v-toolbar
            flat
            color="blue-grey"
            dense
            dark
            height="20"
          >
            <v-toolbar-title>Duration</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1">
          <v-edit-dialog
            @save="update(
              {
               duration: poi.duration,
               show_poi: true,
              },
              'duration'
             )"
          >
            <span>Average (min):</span>
            <span class="font-weight-black">
               {{ poi.duration && poi.duration.avg ? poi.duration.avg : 'empty' }}
            </span>
            <template v-slot:input>
              <v-text-field
                v-model="poi.duration.avg"
                label="Average duration (min)"
                clearable
              />
            </template>
          </v-edit-dialog>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1">
          <v-edit-dialog
            ref="durationDialog"
          >
            <div class="my-1">
              <span>Minimal (hr):</span>
              <span class="font-weight-black">
                 {{ poi.duration && poi.duration.min ? poi.duration.min : 'empty' }}
              </span>
            </div>
            <div class="my-1">
              <span>Maximal (hr):</span>
              <span class="font-weight-black">
                {{ poi.duration && poi.duration.max ? poi.duration.max : 'empty' }}
              </span>
            </div>
            <template v-slot:input>
              <v-form v-model="durationForm.isValid">
                <v-alert
                  class="mt-1"
                  v-if="!poi.duration && !poi.duration.avg"
                  type="info"
                  outlined
                  dense
                >Set average duration first
                </v-alert>
                <v-alert
                  class="mt-1"
                  v-if="durationForm.isNotComplete"
                  type="error"
                  outlined
                  dense
                >Set or delete both values
                </v-alert>
                <v-text-field
                  :disabled="!poi.duration && !poi.duration.avg"
                  v-model="poi.duration.min"
                  label="Minimal duration (hr)"
                  @keydown.enter.stop="updateDuration"
                  clearable
                />
                <v-text-field
                  :disabled="!poi.duration && !poi.duration.avg"
                  v-model="poi.duration.max"
                  label="Maximal duration (hr)"
                  @keydown.enter.stop="updateDuration"
                  clearable
                />
              </v-form>
            </template>
          </v-edit-dialog>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters>
          <v-toolbar
            flat
            color="blue-grey"
            dense
            dark
            height="20"
          >
            <v-toolbar-title>Distance</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1">
          <v-edit-dialog
            ref="distanceDialog"
          >
            <div class="my-1">
              <span>Minimal:</span>
              <span class="font-weight-black">
                 {{ poi.distance ? poi.distance.min : 'empty' }}
              </span>
            </div>
            <div class="my-1">
              <span>Maximal:</span>
              <span class="font-weight-black">
                {{ poi.distance ? poi.distance.max : 'empty' }}
              </span>
            </div>
            <template v-slot:input>
              <v-form>
                <v-text-field
                  :disabled="!poi.distance"
                  v-model="poi.distance.min"
                  label="Minimal distance"
                  type="number"
                  @keydown.enter.stop="updateDistance"
                  clearable
                />
                <v-text-field
                  :disabled="!poi.distance"
                  v-model="poi.distance.max"
                  label="Maximal distance"
                  type="number"
                  @keydown.enter.stop="updateDistance"
                  clearable
                />
              </v-form>
            </template>
          </v-edit-dialog>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-row dense no-gutters>
          <v-col>
            Hashtags:
            <v-btn
              text color="teal accent-4" fab
              @click="showHashtagsDialog"
              :disabled="isPoiLocked"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-label</v-icon>
                </template>
                add hashtag
              </v-tooltip>
            </v-btn>
            <v-chip
              v-for="tag in poi.hashtags"
              :key="tag.name"
              :close="!isPoiLocked"
              class="mr-2" small
              @click:close="deleteHashtag(tag)"
            >
              {{ tag.name }}
            </v-chip>
          </v-col>
        </v-row>

        <v-row dense no-gutters>
          <v-col>
            Content tags:
            <content-tags
              v-if="poi.id"
              :poi-data="poi"
              :content-tags="contentTags"
              @updatePoiData="updatePoiData"
              :button-disabled="isPoiLocked"
            />
            <v-chip
              v-for="(tag, index) in poi.content_tags"
              :key="index"
              outlined
              class="mr-2" small
              color="black"
              text-color="black"
            >
              {{ tag.name }}
            </v-chip>
          </v-col>
        </v-row>

        <v-tabs
          v-model=pageTab
        >
          <v-tab>
            VIDEO
          </v-tab>
          <v-tab>
            IMAGES
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="pageTab"
        >
          <v-tab-item>
            <v-col
              class="px-0"
            >
              <v-row no-gutters>
                <confirm-dialog
                  :is-open.sync="dialogs.bulkSource.isOpened"
                  dialog-max-width="400"
                  @confirm="setBulkSource"
                  confirm-button-text="save"
                >
                  <template v-slot:activator>
                    <v-btn
                      class="mx-2" color="orange darken-3"
                      small
                      @click="openDialog('bulkSource')"
                      :disabled="!selectedVideoIdsList.length || isPoiLocked"
                    >
                      Change source
                    </v-btn>
                  </template>
                  <template v-slot:title>
                    Set source
                  </template>
                  <template v-slot:body>
                    <v-row>
                      Selected videos number: {{ selectedVideoIdsList.length }}
                    </v-row>
                    <v-row>
                      <DataList
                        :item-model.sync="dialogs.bulkSource.data.sourceId"
                        :type-object="$constants.DATA_LISTS.VIDEO_SOURCES_LIST"
                        label="source"
                      />
                    </v-row>
                    <v-row
                    v-if="dialogs.bulkSource.data.sourceId === $constants.VIDEO_SOURCES.AMBASSADOR"
                    >
                      <AmbassadorList
                        :ambassador-model.sync="dialogs.bulkSource.data.ambassadorId"
                      />
                    </v-row>
                  </template>
                </confirm-dialog>
              </v-row>

              <v-row no-gutters>
                <MediaVideoTable
                  v-if="isPoiAttraction"
                  :items.sync="poi.videos_all"
                  :poi-id="poi.id"
                  :selected-items.sync="selectedItems"
                  ref="videoDataRef"
                  @error="showErrorMessage"
                />

                <v-expansion-panels v-if="isPoiAttraction && poi.videos_all">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                  Archived videos ({{ poi.videos_all.filter((el) => el.is_archive === 1).length }})
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <MediaVideoTable
                        :items.sync="poi.videos_all"
                        :poi-id="poi.id"
                        :show-archive="true"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </v-col>
          </v-tab-item>
          <v-tab-item>
            <v-col
              class="px-0"
            >
              <v-row no-gutters>
                <media-images-table
                  :items.sync="poi.poi_images_all"
                  :object-id="poi.id"
                  path="poiImage"
                />

                <v-expansion-panels v-if="poi.poi_images_all">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Archived images ({{ poi.poi_images_all.filter((el) => el.is_archive === 1).length }})
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <media-images-table
                          :items.sync="poi.poi_images_all"
                          :object-id="poi.id"
                          path="poiImage"
                          :show-archive="true"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
      </v-col>

      <v-col cols="2">
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1">
          <v-toolbar
            flat
            color="blue-grey"
            dense
            dark
            height="20"
          >
            <v-toolbar-title>Headline</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1">

          <translations-bar
            :id="poi.id"
            :translations="translationsHeadline[poi.id] ? translationsHeadline[poi.id] : {}"
            :model="$constants.TRANSLATION_MODELS.POI_HEADLINE"
            :title="poi.name ? poi.name : ''"
            :trigger-update="poi.headline"
          >
          </translations-bar>

          <text-card
            :text="poi.headline ? poi.headline : 'empty'"
            v-on:remove="update(
              {
               headline: null,
               show_poi: true
              },
              'headline'
            )"
            v-on:edit="showTextDialog('headline', 'simple')"
          />
        </v-row>
        <v-row dense no-gutters class="my-1">
          <v-toolbar
            flat
            color="blue-grey"
            dense
            dark
            height="20"
          >
            <v-toolbar-title>Description</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row dense no-gutters class="my-1">

          <translations-bar
            :id="poi.id"
            :translations="translationsDescription[poi.id] ? translationsDescription[poi.id] : {}"
            :model="$constants.TRANSLATION_MODELS.POI_DESCRIPTION"
            :title="poi.name ? poi.name : ''"
            :trigger-update="poi.description"
          >
          </translations-bar>

          <text-card
            :text="poi.description ? poi.description.replaceAll('\n', '<br/>') : 'empty'"
            v-on:remove="update(
              { description: null, show_poi:true },
              'description'
              )"
            v-on:edit="showTextDialog('description')"
          />
        </v-row>
        <v-row dense no-gutters class="my-1">
          <v-toolbar
            flat
            color="blue-grey"
            dense
            dark
            height="20"
          >
            <v-toolbar-title>Highlights</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row dense no-gutters class="my-1">

          <translations-bar
            :id="poi.id"
            :translations="translationsHighlights[poi.id] ? translationsHighlights[poi.id] : {}"
            :model="$constants.TRANSLATION_MODELS.POI_HIGHLIGHTS"
            :title="poi.name ? poi.name : ''"
            :trigger-update="poi.highlights"
          >
          </translations-bar>

          <text-card
            :text="poi.highlights ? poi.highlights.replaceAll('\n', '<br/>') : 'empty'"
            v-on:remove="update(
              {
               highlights: null,
               show_poi: true
              },
              'highlights'
            )"
            v-on:edit="showTextDialog('highlights', 'simple')"
          />
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1">
          <v-toolbar
            flat
            color="blue-grey"
            dense
            dark
            height="20"
          >
            <v-toolbar-title>Tips</v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row
          v-if="isPoiAttraction"
          dense no-gutters class="my-1">

          <translations-bar
            :id="poi.id"
            :translations="translationsTips[poi.id] ? translationsTips[poi.id] : {}"
            :model="$constants.TRANSLATION_MODELS.POI_TIPS"
            :title="poi.name ? poi.name : ''"
            :trigger-update="poi.tips"
          >
          </translations-bar>

          <text-card
            :text="poi.tips ? poi.tips : 'empty'"
            v-on:remove="update(
              {
               tips: null,
               show_poi: true
              },
              'tips'
            )"
            v-on:edit="showTextDialog('tips')"
          />
        </v-row>
      </v-col>

      <v-col cols="2">
        <v-row  class="text-right pt-0 pb-1">
          <v-col>
            <poi-dialog-text-to-speech
              v-if="poi.id"
              :poi-id="poi.id.toString()"
              :poi-name="poi.name"
              :button-disabled="isPoiLocked"
            />
          </v-col>
          <v-col>
            <open-ai
              v-if="poi.id"
              :poi-data="poi"
              @updatePoiData="updatePoiData"
              :button-disabled="isPoiLocked"
            />
          </v-col>
          <v-col>
            <v-dialog
              v-model="reviewDialog.show"
              max-width="75%"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                  small
                  :disabled="isPoiLocked"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon
                          @click="reviewDialog.item = {}"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-plus
                        </v-icon>
                      </slot>
                    </template>
                    add new review
                  </v-tooltip>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Review</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="reviewDialog.item.captionprovider_id"
                          :items="providers"
                          :filter="nonDiacriticsSensitiveFilter"
                          label="Provider"
                          item-text="name"
                          clearable
                          item-value="id"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-textarea
                          counter
                          label="Text"
                          v-model="reviewDialog.item.text"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="reviewDialog.show = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :loading="reviewDialog.loading"
                    :disabled="!reviewDialog.item.text
                     || !reviewDialog.item.captionprovider_id
                     || isPoiLocked"
                    color="blue darken-1"
                    text
                    @click="saveReview"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>

        <translations-bar
          :id="poi.id"
          :translations="translationsReviews ? translationsReviews : {}"
          :model="$constants.TRANSLATION_MODELS.REVIEW"
          :title="poi.name ? poi.name : ''"
          :popup="false"
        >
        </translations-bar>

        <draggable v-model="poi.reviews" @change="updateReviewOrder">
          <review-card
            v-for="review in poi.reviews"
            :key="review.id"
            :review="review"
            v-on:remove="removeReview(review)"
            v-on:edit="showEditReviewDialog(review)"
          />
        </draggable>
      </v-col>
    </v-row>

    <v-dialog
      width="500"
      v-model="textDialog.show"
    >
      <v-card>
        <v-card-title>{{ textDialog.type ? textDialog.type.toUpperCase() : '' }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-if="textDialog.editor === 'simple'"
            v-model="textDialog.text"
            outlined
            height="300"
          ></v-textarea>
          <div
            v-else-if="textDialog.isShowHtml === true"
          >{{ this.$store.state.richeditor.text }}</div>
          <editor v-else/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="textDialog.editor !== 'simple'"
            color="blue darken-1"
            text
            @click="toggleHtml"
          >
            {{ textDialog.isShowHtml ? 'Hide' : 'Show' }} HTML
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="hideTextDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="textDialog.loading"
            color="blue darken-1"
            text
            @click="saveText"
            :disabled="isPoiLocked"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="hashtagdialog.show"
      width="500"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-autocomplete
                  ref="hashtagselect"
                  item-text="name"
                  label="hashtags"
                  clearable
                  chips
                  multiple
                  v-model="hashtagdialog.hashtags"
                  :items="hashtags"
                  :filter="nonDiacriticsSensitiveFilter"
                  return-object
                  :menu-props="{ closeOnContentClick: true }"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="hideHashtagsDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!hashtagdialog.hashtags || isPoiLocked"
            @click="addHashtags(hashtagdialog.hashtags)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogVideoUpload
      v-if="isPoiAttraction"
      :show.sync="videoUploadDialog.show"
      :is-direct-upload="videoUploadDialog.isDirectUpload"
      :is-poi-enabled="poi.enabled"
      :poi-id="Number(this.$route.params.id)"
      @videoWasSaved="videoWasSaved"
      @errorUpload="errorUpload"
      @videoWasUploaded="videoWasUploaded"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import ImageUploadDialog from '../components/dialogs/ImageUploadDialog.vue';
import PoiDialogTextToSpeech from '../components/dialogs/PoiDialogTextToSpeech.vue';
import ReviewCard from '../components/ReviewCard.vue';
import TextCard from '../components/TextCard.vue';
import Editor from '../components/Editor.vue';
import DialogVideoUpload from '../components/dialogs/DialogVideoUpload.vue';
import fetchErrorMixin from '../mixins/fetchErrorMixin';
import OpenAi from '../components/dialogs/OpenAi.vue';
import MediaImagesTable from '../components/MediaImagesTable.vue';
import MediaVideoTable from '../components/MediaVideoTable.vue';
import TranslationsBar from '../components/Translations/TranslationsBar.vue';
import ContentTags from '../components/dialogs/ContentTags.vue';
import ConfirmDialog from '../components/dialogs/ConfirmDialog.vue';
import manageDialogsMixin from '../mixins/manageDialogsMixin';
import AmbassadorList from '../components/DataLists/AmbassadorList.vue';
import DataList from '../components/DataLists/DataList.vue';

export default {
  name: 'PoiShow',
  components: {
    ImageUploadDialog,
    DataList,
    AmbassadorList,
    ConfirmDialog,
    ContentTags,
    TranslationsBar,
    PoiDialogTextToSpeech,
    Editor,
    ReviewCard,
    TextCard,
    draggable,
    DialogVideoUpload,
    OpenAi,
    MediaImagesTable,
    MediaVideoTable,
  },

  mixins: [
    fetchErrorMixin,
    manageDialogsMixin,
  ],

  props: {
    type: {
      type: String,
    },
  },

  data: () => ({
    timer: null,
    poiTable: {},
    priceCategories: [
      'not set',
      '$',
      '$$',
      '$$$',
    ],

    poiIdToChange: null,
    durationForm: {
      isNotComplete: false,
      isValid: false,
    },
    rules: {
      required: (v) => !!v || 'Both will save empty',
    },
    providers: [],
    textDialog: {
      show: false,
      loading: false,
      type: null,
      text: null,
      editor: null,
      isShowHtml: false,
    },
    tripexpert: {
      url: null,
      venue: null,
      id: null,
    },
    hashtagdialog: {
      show: false,
      hashtags: [],
    },
    contentTags: [],
    wikidialog: {
      dialog: false,
      id: null,
    },
    hashtags: [],

    poi: {
      type: '',
      name: false,
      videos: false,
      duration: {},
      distance: {},
      price: null,
    },

    parsedAddress: {
      poiId: null,
      street1: '',
      street2: '',
      city: '',
      state: '',
      postal_code: '',
      country: '',
    },

    reviewDialog: {
      show: false,
      item: {},
      loading: false,
    },
    previewPriorityDialog: {
      show: false,
      previewsAmount: null,
      video: null,
      isAccept: false,
    },

    videoUploadDialog: {
      show: false,
      isDirectUpload: false,
    },

    translationsHeadline: {},
    translationsDescription: {},
    translationsHighlights: {},
    translationsTips: {},
    translationsReviews: {},

    selectedItems: [],

    dialogs: {
      bulkSource: {
        isOpened: false,
        data: {
          sourceId: null,
          ambassadorId: null,
        },
        defaults: {
          sourceId: null,
          ambassadorId: null,
        },
      },
    },

    pageTab: null,
  }),

  created() {
    this.parsedAddress.poiId = this.$route.params.id;
    this.poiTable = !localStorage[`table_options_${this.computedType.toLowerCase()}poi`]
      ? {}
      : JSON.parse(localStorage[`table_options_${this.computedType.toLowerCase()}poi`]);
    this.fetchFilledData();
    this.fetchData();

    this.$requestHelpers
      .get('api/admin/content-tags')
      .then((response) => {
        this.contentTags = response.data.result;
      });
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    errorUpload(errorMsg) {
      this.showErrorMessage(errorMsg);
    },

    startCountdown() {
      const countDownInterval = setInterval(() => {
        if (!this.timer) {
          clearInterval(countDownInterval);
          return;
        }

        this.timer -= 1;
      }, 1000);
    },

    async fetchFilledData() {
      await this.$requestHelpers
        .get('api/admin/providers')
        .then((response) => {
          this.providers = response.data;
        });

      await this.$requestHelpers.get('api/admin/hashtag')
        .then((response) => {
          this.hashtags = response.data;
        });
    },

    async fetchData() {
      this.timer = 0;
      this.startCountdown();

      if (!this.$route.params.id) {
        return;
      }

      await this.$requestHelpers
        .get(`api/admin/poi/poiFullInfo/${this.$route.params.id}`)
        .then((response) => {
          this.poi = response.data.result;

          this.tripexpert.id = this.poi.tripexpert_id;

          if (!this.poi.duration) {
            this.poi.duration = {};
          }

          if (this.poi.videos_all) {
            this.poi.videos_all.sort((a, b) => a.poi_relation.priority - b.poi_relation.priority);
          }

          this.wikidialog.id = this.poi.wikipoi_id;

          if (this.poi.tripexpert_id) {
            this.$requestHelpers.get(`api/admin/tripexpert/venues/${this.poi.tripexpert_id}`)
              .then((venue) => {
                this.tripexpert.venue = venue.data;

                this.tripexpert.url = this.tripexpert.venue.full_path;
              });
          }

          this.getTranslationsByTypes();
        });
    },

    getTranslationsByTypes() {
      if (!this.poi.id) {
        return;
      }

      this.$requestHelpers.post(
        'api/admin/bulk-translations-by-types',
        {
          models: [
            this.$constants.TRANSLATION_MODELS.POI_HEADLINE,
            this.$constants.TRANSLATION_MODELS.POI_DESCRIPTION,
            this.$constants.TRANSLATION_MODELS.POI_HIGHLIGHTS,
            this.$constants.TRANSLATION_MODELS.POI_TIPS,
          ],
          ids: [this.poi.id],
        },
      ).then((response) => {
        // eslint-disable-next-line max-len
        this.translationsHeadline = response.data.result[this.$constants.TRANSLATION_MODELS.POI_HEADLINE];
        // eslint-disable-next-line max-len
        this.translationsDescription = response.data.result[this.$constants.TRANSLATION_MODELS.POI_DESCRIPTION];
        // eslint-disable-next-line max-len
        this.translationsHighlights = response.data.result[this.$constants.TRANSLATION_MODELS.POI_HIGHLIGHTS];
        this.translationsTips = response.data.result[this.$constants.TRANSLATION_MODELS.POI_TIPS];
      });

      this.$requestHelpers.get(
        `api/admin/poi-reviews-translations/${this.poi.id}`,
      ).then((response) => {
        this.translationsReviews = response.data.result;
      });
    },

    update(request, origField) {
      const modifiedItem = { ...this.poi.id, ...request };

      return this.$requestHelpers
        .patch(`api/admin/poi/${this.poi.id}`, modifiedItem)
        .then((response) => {
          this.$set(this.poi, origField, response.data.result[origField]);
        })
        .catch((response) => {
          if (response?.data?.result && origField in response.data.result) {
            this.$set(this.poi, origField, response.data.result[origField]);
          }
        });
    },

    showVideoUploadDialog(isDirectUpload = false) {
      this.videoUploadDialog.isDirectUpload = isDirectUpload;
      this.videoUploadDialog.show = true;
    },

    videoWasSaved(item) {
      this.setSnack({
        color: 'green',
        text: 'saved',
      });
      this.poi.videos_all.push(item);
    },

    videoWasUploaded(response) {
      if (response.data.success) {
        this.setSnack({
          color: 'green',
          text: 'saved',
        });
      } else {
        this.setSnack({
          color: 'red',
          text: response.data.message,
        });
      }
      this.poi.videos_all.push(response.data.result);
    },

    showErrorMessage(message) {
      this.setSnack({
        color: 'red',
        text: message,
      });
    },

    openPlayVideoDialog(videoSrc) {
      Object.assign(this.videoDialog, { show: true, src: videoSrc });
    },

    saveReview() {
      this.reviewDialog.loading = true;
      this.reviewDialog.item.poi_id = this.poi.id;

      if (this.reviewDialog.item.id) {
        this.$requestHelpers
          .patch(
            `api/admin/reviews/${this.reviewDialog.item.id}`,
            this.reviewDialog.item,
          )
          .then((response) => {
            const item = this.poi.reviews.find(
              (review) => review.id === this.reviewDialog.item.id,
            );
            if (item) Object.assign(item, response.data);
          }).finally(() => {
            this.reviewDialog.show = false;
            this.reviewDialog.loading = false;
            this.reviewDialog.item = {};
          });

        return;
      }

      this.$requestHelpers
        .post('api/admin/reviews', this.reviewDialog.item)
        .then((response) => {
          this.poi.reviews.push(response.data);
        })
        .finally(() => {
          this.reviewDialog.show = false;
          this.reviewDialog.item = {};
          this.reviewDialog.loading = false;
        });
    },

    updateDuration() {
      this.poi.duration.min = this.poi.duration.min === ''
        ? null
        : this.poi.duration.min;
      this.poi.duration.max = this.poi.duration.max === ''
        ? null
        : this.poi.duration.max;
      if (
        (this.poi.duration.min !== null
          && this.poi.duration.max !== null)
        || (
          this.poi.duration.min == null
          && this.poi.duration.max == null
        )
      ) {
        this.durationForm.isNotComplete = false;
        this.$refs.durationDialog.save();
        this.update(
          {
            duration: this.poi.duration,
            show_poi: true,
          },
          'duration',
        );
      } else {
        this.durationForm.isNotComplete = true;
      }
    },

    updateDistance() {
      this.$refs.distanceDialog.save();
      this.update(
        {
          distance: this.poi.distance,
          show_poi: true,
        },
        'distance',
      );
    },

    deleteHashtag(hashtag) {
      this.update({ remove_hashtag: hashtag }, 'hashtags');
    },

    addHashtags(hashtags) {
      this.update({ add_hashtags: hashtags }, 'hashtags').finally(() => {
        this.hideHashtagsDialog();
      });
    },

    getTripexpert(type) {
      const params = {
        poi_id: this.$route.params.id,
      };

      if (type === 'tripexpert_id') {
        params.tripexpert_id = this.tripexpert.id;
      }

      if (type === 'url') {
        params.url = this.tripexpert.url;
      }

      this.$requestHelpers
        .get('api/admin/tripexpertData', {
          params,
        })
        .then((response) => {
          if (response) {
            this.poi = response.data.poi;
            this.tripexpert.id = response.data.tripexpert_id;
            this.tripexpert.url = response.data.url;
          }
        });
    },

    setWikipoiId() {
      this.$requestHelpers
        .patch(`api/admin/poi/${this.poi.id}`, { wikipoi_id: this.wikidialog.id })
        .then(() => {
          this.poi.wikipoi_id = this.wikidialog.id;
          window.open(
            this.wikipoiUrl,
            '_blank',
          );

          this.wikidialog.dialog = false;
          this.setSnack({
            color: 'green',
            text: 'saved',
          });
        });
    },

    removeReview(review) {
      this.$requestHelpers
        .delete(`api/admin/reviews/${review.id}`)
        .then(() => {
          this.poi.reviews = this.poi.reviews.filter((e) => e.id !== review.id);
        });
    },

    showEditReviewDialog(item) {
      this.reviewDialog.show = true;
      this.reviewDialog.item = { ...item };
    },

    showHashtagsDialog() {
      Object.assign(this.hashtagdialog, { show: true, hashtags: [] });
    },

    hideHashtagsDialog() {
      Object.assign(this.hashtagdialog, { show: false, hashtags: [] });
    },

    showTextDialog(type = 'description', editor) {
      let text = '';

      switch (type) {
        case 'tips':
          text = this.poi.tips;
          break;
        case 'description':
          text = this.poi.description;
          break;
        case 'highlights':
          text = this.poi.highlights;
          break;
        case 'headline':
          text = this.poi.headline;
          break;
        default:
          text = '';
      }
      Object.assign(
        this.textDialog,
        {
          show: true,
          type,
          text,
          editor,
        },
      );

      this.$store.commit('richeditor/setText', text);
    },

    toggleHtml() {
      this.textDialog.isShowHtml = !this.textDialog.isShowHtml;
    },

    hideTextDialog() {
      Object.assign(
        this.textDialog,
        {
          show: false,
          type: null,
          text: '',
          editor: null,
          isShowHtml: false,
        },
      );
    },

    saveText() {
      let textUpdate;
      switch (this.textDialog.type) {
        case 'tips':
        case 'description':
          textUpdate = this.saveRichText(this.textDialog.type);
          break;
        case 'highlights':
        case 'headline':
          textUpdate = this.update({
            [this.textDialog.type]: this.textDialog.text.trim(),
            show_poi: true,
          },
          this.textDialog.type);
          break;
        default:
          return;
      }

      textUpdate.finally(() => {
        this.hideTextDialog();
      });
    },

    saveRichText(type) {
      const { text } = this.$store.state.richeditor;

      // clear "empty" text
      let textTrimmed = text.trim();
      textTrimmed = textTrimmed.replace(/<p>(\s*)<\/p>/, '');
      textTrimmed = textTrimmed.replaceAll('<li><p>', '<li>');
      textTrimmed = textTrimmed.replaceAll('</p></li>', '</li>');

      // eslint-disable-next-line no-param-reassign
      this.textDialog.text = textTrimmed === '<p></p>' ? '' : textTrimmed;

      return this.update({
        [type]: this.textDialog.text,
        show_poi: true,
      },
      type);
    },

    updatePoiData(data) {
      Object.assign(this.poi, data);
    },

    uploadImage(response, isSuccess) {
      if (isSuccess) {
        this.poi.poi_images_all.push(response.data.result);
      }

      return true;
    },

    updateReviewOrder() {
      const newOrder = this.poi.reviews.map((el, index) => ({
        id: el.id,
        order: index,
      }));
      this.$requestHelpers
        .post('api/admin/reviews/order', { newOrder })
        .then(() => {
        });
    },

    setBulkSource() {
      if (!this.selectedItems.length || !this.dialogs.bulkSource.data.sourceId) {
        this.closeDialog('bulkSource');
        return false;
      }

      this.updateBulkVideo(
        this.selectedItems.map((item) => item.id),
        {
          source_id: this.dialogs.bulkSource.data.sourceId,
          ambassador_id: this.dialogs.bulkSource.data.ambassadorId,
        },
      ).finally(() => {
        this.closeDialog('bulkSource');
      });

      return true;
    },

    updateBulkVideo(videoIds, videoFields) {
      return this.$refs.videoDataRef.updateBulk(videoIds, videoFields);
    },
  },

  computed: {
    ...mapGetters({
      standby: 'overlay/show',
    }),

    poiTableOptionsSet() {
      return ({
        border: `2px solid #${this.poiTable.isEmptyFilter ? 'fff' : 'ccc'}`,
      });
    },

    wikipoiUrl() {
      return `https://wikipoi.flightpath3d.com/pages/view/${this.poi.wikipoi_id}`;
    },

    computedType() {
      return this.type ? this.type : this.$constants.POI_TYPES.ATTRACTION;
    },

    isPoiRestaurant() {
      return this.computedType === this.$constants.POI_TYPES.RESTAURANT;
    },

    isPoiHotel() {
      return this.computedType === this.$constants.POI_TYPES.HOTEL;
    },

    isPoiAttraction() {
      return this.computedType === this.$constants.POI_TYPES.ATTRACTION;
    },

    localStorageTableOptionsName() {
      return `${this.computedType.toLowerCase()}_table_options`;
    },

    localStorageTableOptionsColorName() {
      return `${this.computedType.toLowerCase()}_table_options_color`;
    },

    localStoragePoiFiltersName() {
      return `${this.computedType.toLowerCase()}_filters`;
    },

    localStoragePoiFiltersColorName() {
      return `${this.computedType.toLowerCase()}_filters_color`;
    },

    poiRouterName() {
      return `${this.computedType.toLowerCase()}Show`;
    },

    computedPriceCategories() {
      return this.priceCategories
        .map((el) => ({
          id: el === 'not set' ? null : el,
          name: el,
        }));
    },

    selectedVideoIdsList() {
      return this.selectedItems.map(
        (item) => item.id,
      );
    },

    isPoiLocked() {
      return !!this.poi.is_locked;
    },
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.card-actions-left {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0;
}

.card-actions-right {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0;
}
</style>
